import SiafLiteApiRepository from "../../external/siafLiteApi";
import CepPromise from "cep-promise";

class EnderecoService {
  constructor() {
    this.urlBase = "/integracao/enderecos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getEstados() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/estados`).get();
  }

  getPaises() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/paises`).get();
  }

  getCidadeById(id) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/cidade/${id}`).get();
  }

  getCidadeByCodigo(codigo) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/municipio/${codigo}`
    ).get();
  }

  getCidades(ufid) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/cidades/${ufid}`
    ).get();
  }

  async buscarEndereco(cep) {
    try {
      const endereco = await CepPromise(cep);
      const {
        city: cidade,
        street: logradouro,
        neighborhood: bairro,
        state: uf,
      } = endereco;
      return { cidade, logradouro, bairro, uf };
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  }

  getByCep(cep) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/cep/${cep}`).get();
  }

  deleteEnderecoPessoa(id) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}`).delete(id);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }
}

export default EnderecoService;
